'use strict';

module.exports = [require('./format'), require('./print')];


//////////////////
// WEBPACK FOOTER
// ./~/mathjs/lib/function/string/index.js
// module id = 1124
// module chunks = 0